"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tail = exports.TailWrapper = exports.StandardTailName = exports.StandardTailAnchor = exports.StandardTailBoundingBox = exports.StandardTailClickableArea = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _hotspotGlobal = require("../../hotspot.global.styles");

var _hotspot = require("../../hotspot.styles");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var StandardTailClickableArea = _styledComponents.default.div.withConfig({
  displayName: "StandardTailstyles__StandardTailClickableArea",
  componentId: "sc-11khck9-0"
})(["animation:", ";animation-iteration-count:1;animation-fill-mode:forwards;background:", ";border:none;cursor:pointer;font-size:inherit;opacity:", ";padding:0;"], function (_ref) {
  var playing = _ref.playing,
      shouldFadeOut = _ref.shouldFadeOut;
  return (0, _hotspot.fade)(playing, shouldFadeOut);
}, _hotspotGlobal.colors.transparent, function (_ref2) {
  var hotspotOpacity = _ref2.hotspotOpacity;
  return hotspotOpacity;
});

exports.StandardTailClickableArea = StandardTailClickableArea;

var StandardTailBoundingBox = _styledComponents.default.div.attrs(function (_ref3) {
  var dimensions = _ref3.dimensions,
      customPlayer = _ref3.customPlayer;
  return {
    style: {
      height: "".concat(dimensions.height, "%"),
      left: "".concat(dimensions.left, "%"),
      top: "".concat(dimensions.top, "%"),
      width: "".concat(dimensions.width, "%"),
      zIndex: dimensions.zIndex,
      pointerEvents: "".concat(customPlayer ? 'auto' : '')
    }
  };
}).withConfig({
  displayName: "StandardTailstyles__StandardTailBoundingBox",
  componentId: "sc-11khck9-1"
})(["align-items:center;display:flex;justify-content:center;position:absolute;", ""], function (_ref4) {
  var hideAnchor = _ref4.hideAnchor;
  return hideAnchor && 'opacity: 0;';
});

exports.StandardTailBoundingBox = StandardTailBoundingBox;

var StandardTailAnchor = _styledComponents.default.div.withConfig({
  displayName: "StandardTailstyles__StandardTailAnchor",
  componentId: "sc-11khck9-2"
})(["background:", ";border:", ";border-radius:50%;height:1.3em;width:1.3em;"], function (_ref5) {
  var config = _ref5.config;
  return config.backgroundColor;
}, function (_ref6) {
  var config = _ref6.config;
  return "1px solid ".concat(config.borderColor);
});

exports.StandardTailAnchor = StandardTailAnchor;

var StandardTailName = _styledComponents.default.button.attrs(function (_ref7) {
  var position = _ref7.position,
      customPlayer = _ref7.customPlayer;
  return {
    style: {
      left: "".concat(position.left, "%"),
      top: "".concat(position.top, "%"),
      pointerEvents: "".concat(customPlayer ? 'auto' : '')
    }
  };
}).withConfig({
  displayName: "StandardTailstyles__StandardTailName",
  componentId: "sc-11khck9-3"
})(["background:", ";border:", ";border-radius:", ";color:", ";font-size:2.1em;padding:0.4em 0.9em;line-height:1;position:absolute;white-space:nowrap;cursor:pointer;"], function (_ref8) {
  var config = _ref8.config;
  return config.backgroundColor;
}, function (_ref9) {
  var _ref9$config = _ref9.config,
      borderColor = _ref9$config.borderColor,
      borderStyle = _ref9$config.borderStyle,
      borderWidth = _ref9$config.borderWidth;
  return "".concat(borderWidth, " ").concat(borderStyle, " ").concat(borderColor);
}, function (_ref10) {
  var borderRadius = _ref10.config.borderRadius;
  return borderRadius;
}, function (_ref11) {
  var config = _ref11.config;
  return config.color;
});

exports.StandardTailName = StandardTailName;

var TailWrapper = _styledComponents.default.svg.attrs(function (_ref12) {
  var height = _ref12.height,
      left = _ref12.left,
      top = _ref12.top,
      width = _ref12.width;
  return {
    focusable: false,
    style: {
      height: "".concat(height, "px"),
      left: "".concat(left, "px"),
      top: "".concat(top, "px"),
      width: "".concat(width, "px")
    }
  };
}).withConfig({
  displayName: "StandardTailstyles__TailWrapper",
  componentId: "sc-11khck9-4"
})(["position:absolute;pointer-events:none;", ""], function (_ref13) {
  var hideAnchor = _ref13.hideAnchor;
  return hideAnchor && 'opacity: 0;';
});

exports.TailWrapper = TailWrapper;

var Tail = _styledComponents.default.line.withConfig({
  displayName: "StandardTailstyles__Tail",
  componentId: "sc-11khck9-5"
})(["opacity:0.5;pointer-events:auto;stroke-width:1px;"]);

exports.Tail = Tail;